var $8216342ef7e6a5ba$exports = {};
$8216342ef7e6a5ba$exports = {
    "more": `Mais artigos`
};


export {$8216342ef7e6a5ba$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
